module.exports = __webpack_public_path__ + "static/img/SIMON_ODONNELL.71f6ce9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SIMON_ODONNELL.jpg
// module id = lWFg
// module chunks = 0